import { useState, useCallback, useEffect, useRef } from "react";
import useApi from "../../hooks/useApi";
import {
  Autocomplete,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

import Modal from "../common/CommonModal";
import CreditCustomerList from "../common/CreditCustomerList";

function AutoCompleteCommon(props) {
  // const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: "", // 'add', 'cr-list'
    customer: null,
  });

  const closeModal = () => {
    setModalState({
      isOpen: false,
      type: "",
      customer: null,
    });
  };

  const {
    setMethod,
    selectedvalue,
    typeOfAutocomplete,
    accountSearchText = "",
  } = props;
  const autocompleteRef = useRef();

  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");

  const COMPANY_CODE = localStorage?.getItem("companyCode") || "";

  const { request, loading: loadingSupplier } = useApi();
  const [suggestionsDepreciation, setSuggestionsDepreciation] = useState([]);
  const [inputValueDepreciation, setInputValueDepreciation] = useState("");

  const fetchCreditSuppliers = async (query = "-") => {
    const safeQuery = encodeURIComponent(query);
    const url = `${BASE_URL}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${DEPARTMENT}/all/-/${safeQuery}`;

    console.log("url get account list", url);
    try {
      const response = await request({
        url: url,
        method: "GET",
        timeout: 1000,
      });
      return response || [];
    } catch (err) {
      console.error("Failed to fetch credit suppliers", err);
      return [];
    }
  };

  const fetchSuggestionsDepreciation = useCallback(
    async (query) => {
      if (!query || query.trim().length === 0) {
        setSuggestionsDepreciation([]);
        return;
      }

      const freetext = query.trim();

      const result = await fetchCreditSuppliers(freetext);
      setSuggestionsDepreciation(result || []);
    },
    [BASE_URL, COMPANY_CODE, DEPARTMENT],
  );

  useEffect(() => {
    console.log("inputValueDepreciation", inputValueDepreciation);
    const debounceTimeout = setTimeout(() => {
      fetchSuggestionsDepreciation(inputValueDepreciation);
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [inputValueDepreciation, fetchSuggestionsDepreciation]);

  useEffect(() => {
    console.log("accountSearchText", accountSearchText);
    if (accountSearchText) {
      setInputValueDepreciation(accountSearchText);
    }
  }, [accountSearchText]); // Triggers when the parent passes a new account

  const handleDepreciationChange = (event, newValue) => {
    console.log("Depreciation account Value", newValue);
    setMethod(newValue);

    console.log("Depreciation account", newValue);
  };

  const getOptionLabel = (option) => {
    if (!option) return "";
    return option.DESCRIPTION || option.name || "";
  };

  useEffect(() => {
    if (selectedvalue === null) {
      setInputValueDepreciation(""); // Clears the text field
      setSuggestionsDepreciation([]); // Clears old search results
    } else if (
      typeof selectedvalue === "object" &&
      selectedvalue?.DESCRIPTION
    ) {
      // Optional: Keeps text in sync if selection changes elsewhere
      setInputValueDepreciation(selectedvalue.DESCRIPTION);
    }
  }, [selectedvalue]);

  //all this reset cheking and freesolo is used for entering the account from gl list earlier value will come and go blank , to avoid this i did this
  return (
    <div>
      <Autocomplete
        ref={autocompleteRef}
        freeSolo
        value={selectedvalue}
        onChange={handleDepreciationChange}
        inputValue={inputValueDepreciation}
        onInputChange={(event, newInputValue, reason) => {
          console.log(
            "Input change - Reason:",
            reason,
            "Value:",
            newInputValue,
          );

          // Only prevent blank if reason is 'reset' and we have a selectedvalue
          if (reason === "reset" && selectedvalue && newInputValue === "") {
            return; // Don't update to blank
          }

          setInputValueDepreciation(newInputValue);
        }}
        options={suggestionsDepreciation}
        getOptionLabel={getOptionLabel}
        loading={loadingSupplier}
        filterOptions={(x) => x} // Disable built-in filtering
        renderInput={(params) => (
          <TextField
            {...params}
            label={typeOfAutocomplete}
            variant="outlined"
            size="small"
            placeholder="Search"
            onKeyDown={(e) => {
              if (e.key === "F2") {
                e.preventDefault();

                // CLOSE AUTOCOMPLETE SUGGESTIONS
                if (autocompleteRef.current) {
                  autocompleteRef.current.blur();
                }
                setModalState({
                  isOpen: true,
                  type: "cr-list",
                  customer: null,
                });
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loadingSupplier && (
                    <CircularProgress color="inherit" size={20} />
                  )}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props}>
            <div className="flex items-center justify-between w-full">
              <span>{option.DESCRIPTION || option.name}</span>
              {option.ACCOUNT && (
                <Chip
                  label={option.ACCOUNT}
                  size="small"
                  color={"primary"}
                  sx={{ height: 20, fontSize: 10 }}
                />
              )}
            </div>
          </li>
        )}
        noOptionsText={
          inputValueDepreciation.length === 0
            ? "Start typing to search..."
            : "No Data found"
        }
      />
      <div className="p-3 bg-gray-100 flex justify-between rounded-lg">
        <div>
          <span className="text-sm text-gray-600">A/C:</span>{" "}
          <span className="font-bold text-orange-600">
            {selectedvalue?.ACCOUNT || "######"}
          </span>
        </div>
        {/* <div>
          <span className="text-sm text-gray-600">Balance: </span>
          <span
            className={`font-bold ${
              selectedvalue?.BALANCE > 0
                ? "text-green-600"
                : selectedvalue?.BALANCE < 0
                ? "text-red-500"
                : "text-gray-600"
            }`}
          >
            {selectedvalue?.BALANCE ?? "0"}
          </span>
        </div> */}
      </div>

      <Modal
        isOpen={modalState.isOpen}
        onClose={closeModal}
        title={
          modalState.type === "add"
            ? "Add New Supplier"
            : modalState.type === "cr-list"
              ? "Select Account"
              : modalState.type === "job-list"
                ? "Select Job Code"
                : "All"
        }
        size={modalState.type === "add" ? "xxl" : "xxl"}
        header={modalState.type === "add" ? false : true}
      >
        {modalState.type === "cr-list" && (
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={(newValue) => {
              console.log("Supplier data new Value", newValue);
              setMethod(newValue);
              console.log("Selected Supplier", newValue);

              closeModal();
            }}
          />
        )}{" "}
      </Modal>
    </div>
  );
}

export default AutoCompleteCommon;
